import TicketParticipation from "components/UI/ticketParticipation/TicketParticipation";
function TicketParticipationPage() {
    return (
        <div>
            <TicketParticipation />
        </div>
    );
}

export default TicketParticipationPage;